{
    "email" : "E-mail",
    "password" : "Password",
    "managementpanel": "Management Panel",
    "forgotpassword": "Forgot your password?",
    "noaccount": "No account? SIGN UP"
}